/**
 * Per-character portrait data. Placeholder art: emoji + themed color.
 * Swap for authored SVG portraits later without engine changes.
 */

interface Portrait {
  emoji: string;
  color: string;
  accent: string;
}

const PORTRAITS: Record<string, Portrait> = {
  wavy_jones:          { emoji: "🌊", color: "#2f6f9e", accent: "#e6efff" },
  sally_gover:         { emoji: "🌉", color: "#8b5a2b", accent: "#f5e2c8" },
  flying_dutchman:     { emoji: "👻", color: "#4b4e6d", accent: "#e0e3f0" },
  jack_of_all_spades:  { emoji: "🪏", color: "#3a5e3f", accent: "#d7e6d9" },
  chery_pirates:       { emoji: "🍒", color: "#a52a3d", accent: "#f9d0d6" },
  scurvy_sailor:       { emoji: "⛵", color: "#166c85", accent: "#d4ecf3" },
  buccaneer_longlegger:{ emoji: "🦵", color: "#8b4513", accent: "#e6cba8" },
  patches:             { emoji: "🩹", color: "#c56e2b", accent: "#f5d9b8" },
  red_beard:           { emoji: "🧔🏻", color: "#a53228", accent: "#f5c8be" },
  pixie_stix:          { emoji: "🧚", color: "#c8478f", accent: "#f7d0e5" },
  poppy_portage:       { emoji: "🛶", color: "#996a4d", accent: "#f0d9c7" },
  jack_mockingbird:    { emoji: "🐦", color: "#4c6c3a", accent: "#d8e6c8" },
  billy_bootstraps:    { emoji: "💣", color: "#3f3f3f", accent: "#d0d0d0" },
  sticky_fingers:      { emoji: "🤏", color: "#7b5a3d", accent: "#e5d4be" },
  anchovy:             { emoji: "🐟", color: "#4b7b8f", accent: "#d2e2ea" },
  paxie_pan:           { emoji: "🥘", color: "#a26a2b", accent: "#f5d9b8" },
  quack_hawkins:       { emoji: "🦆", color: "#c9a227", accent: "#f7ecb9" },
  bonny_away:          { emoji: "💪", color: "#8b4276", accent: "#e8c8de" },
  one_eyed_guy:        { emoji: "👁️", color: "#3a3a5e", accent: "#d5d5e6" },
  kook_and_sneeze:     { emoji: "👥", color: "#5a5a5a", accent: "#dcdcdc" },
};

const FALLBACK: Portrait = { emoji: "🏴‍☠️", color: "#333", accent: "#ccc" };

export function characterPortrait(id: string | null | undefined): Portrait {
  if (!id) return FALLBACK;
  return PORTRAITS[id] ?? FALLBACK;
}
